import { render, staticRenderFns } from "./DataType.vue?vue&type=template&id=31cb0e28&scoped=true"
import script from "./DataType.vue?vue&type=script&lang=js"
export * from "./DataType.vue?vue&type=script&lang=js"
import style0 from "./DataType.vue?vue&type=style&index=0&id=31cb0e28&prod&lang=stylus&rel=stylesheet%2Fstylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31cb0e28",
  null
  
)

export default component.exports